import { render, staticRenderFns } from "./o-button.vue?vue&type=template&id=2c2351b6&"
import script from "./o-button.vue?vue&type=script&lang=js&"
export * from "./o-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports